import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { parse as qs } from 'qs'
import moment from 'moment-timezone'
import Form from 'components/form-components/form/form'
import { actions, track } from 'react-redux-form'
import { validators } from 'utils/form'
import FormGroup from 'components/form-components/form-group'
import Attachments from 'components/attachments/attachments'
import AgreeTos from 'components/agree-tos'
import FormErrors from 'components/form-components/form-errors'
import getCookie from 'utils/cookie'
import { saveApplication } from 'careers/actions/application'
import { browserHistory } from 'react-router'
import { mapLanguageToComponentProps } from 'i18n'
import LinkListInput from 'components/link-list-input'
import AdditionalFieldsForm from 'components/additional-fields-form'
import { logEvent, EVENT_ACTIONS } from 'actions/audit-trail'
import { LabelledInput } from 'components/form-components/styled-text-input/with-label'
import ThirdPartyScripts from 'careers/components/third-party-scripts'
import PhoneInput from 'components/phone-input'
import { Body, H3, Label } from 'components/styled/typography'
import { Button } from 'components/styled/button'
import ActionBarWrapper from 'components/action-bar-wrapper'
import { PageContent } from 'components/styled/page/page-content'
import { getPreviewActionBarRoot } from 'components/styled/page/preview-app-content'
import { LabelledTextArea } from 'components/form-components/styled-text-area/with-label'
import { addError } from 'actions'

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    jobAdContainer: PropTypes.object.isRequired,
    jobAdApplication: PropTypes.object.isRequired,
  }).isRequired,
  jobAd: PropTypes.shape({
    _id: PropTypes.string,
    language: PropTypes.string,
    slugs: PropTypes.array,
    formSetup: PropTypes.shape({
      attachments: PropTypes.object,
      coverLetter: PropTypes.object,
      email: PropTypes.object,
      links: PropTypes.object,
      name: PropTypes.object,
      phoneNumber: PropTypes.object,
      additionalFormFields: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          type: PropTypes.string,
          required: PropTypes.bool,
        })
      ),
      city: PropTypes.object,
    }).isRequired,
    questions: PropTypes.array.isRequired,
    privacyPolicy: PropTypes.string,
  }).isRequired,
  params: PropTypes.shape({
    language: PropTypes.string.isRequired,
    companySlug: PropTypes.string.isRequired,
    adSlug: PropTypes.string.isRequired,
  }),
  preview: PropTypes.bool,
  application: PropTypes.shape({}).isRequired,
  company: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    slug: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
    query: PropTypes.shape({}),
    pathname: PropTypes.string,
  }),
  context: PropTypes.string,
  submitApplication: PropTypes.func,
}

const defaultProps = {
  preview: false,
  context: 'careers',
  location: undefined,
  params: undefined,
  submitApplication: undefined,
}

const mapStateToProps = state => ({
  application: state.application,
  jobAd: state.jobAd,
})

const { isRequired, isEmail } = validators

export class JobAdApply extends Component {
  constructor(props) {
    super(props)

    let query = null
    if (props.context === 'careers') {
      let { search } = props.location
      if (search[0] === '?') {
        search = search.substring(1)
      }

      query = qs(search)
    }

    this.state = {
      applicationForm: undefined,
      loading: false,
      invalidFields: [],
      linkedInPictureUrl: null,
      linkedInName: null,
      linkedInAuthorizationCode: query ? query.linkedInCode : undefined,
      linkedInError: query ? query.linkedInError : undefined,
    }

    this.onSubmitApplication = this.onSubmitApplication.bind(this)
    this.submitAdditionalFieldsForm = this.submitAdditionalFieldsForm.bind(this)
    this.onLinkedInProfileData = this.onLinkedInProfileData.bind(this)
    this.onLinkedInAuthorizationRequest =
      this.onLinkedInAuthorizationRequest.bind(this)
  }

  componentDidMount() {
    const { company, dispatch, location } = this.props
    const { linkedInAuthorizationCode, linkedInError } = this.state

    dispatch(
      logEvent({
        ec: company._id,
        ea: EVENT_ACTIONS.jobAdApplyView,
      })
    )

    if (linkedInAuthorizationCode || linkedInError) {
      browserHistory.push({
        pathname: location.pathname,
        search: '',
      })
    }
  }

  onSubmitApplication() {
    const { dispatch, jobAd, params, application } = this.props
    const { applicationForm } = this.state

    dispatch(actions.submit('application'))

    if (applicationForm && applicationForm.valid) {
      const visibleFields = jobAd.additionalFormFields.filter(
        field => field.fieldSetup.visible
      )
      const { invalidFields, linkedInName, linkedInPictureUrl } = this.state

      this.setState({ loading: true })
      // If no video questions mark application completed
      const data =
        jobAd.questions.length === 0 || !jobAd.formSetup.questions.visible
          ? { ...application, jobAd, completed: true }
          : { ...application, jobAd }

      if (linkedInName) {
        data.linkedIn = {
          pictureUrl: linkedInPictureUrl,
        }
      }

      const referrer = getCookie('referrer')
      if (visibleFields.length > 0) {
        document.additionalFieldsForm.submit()
      }
      if (invalidFields.length > 0) {
        this.setState({ loading: false })
        dispatch(
          actions.setSubmitFailed('application.additionalFieldResponses')
        )
      } else {
        dispatch(saveApplication(data, referrer))
          .then(() => {
            this.setState({ loading: false })
            // If we have video question show them otherwise we can go to thank you page
            if (
              jobAd.questions.length > 0 &&
              jobAd.formSetup.questions.visible
            ) {
              browserHistory.push(
                `/careers/${params.language}/${params.companySlug}/${params.adSlug}/interview`
              )
            } else {
              dispatch(actions.reset('application'))
              dispatch(actions.change('application.email', application.email))
              browserHistory.push(
                `/careers/${params.language}/${params.companySlug}/${params.adSlug}/thankyou`
              )
            }
          })
          .catch(err => {
            this.setState({ loading: false })
            dispatch(addError(err))
          })
      }
    } else {
      this.submitAdditionalFieldsForm()
    }
  }

  onChange(model, value) {
    const { dispatch, application } = this.props

    if (model === 'additionalFieldResponse') {
      if (
        application.additionalFieldResponses.find(
          f => f.fieldId === value.fieldId
        )
      ) {
        dispatch(
          actions.change(
            track('application.additionalFieldResponses', {
              fieldId: value.fieldId,
            }),
            value
          )
        )
      } else {
        dispatch(actions.push('application.additionalFieldResponses', value))
      }
    } else {
      dispatch(actions.change(model, value))
    }
    return true
  }

  onLinkedInAuthorizationRequest(csrfToken) {
    window.sessionStorage.setItem('careersLang', this.props.jobAd.language)
    window.sessionStorage.setItem('careersCompany', this.props.company.slug)
    window.sessionStorage.setItem(
      'careersJobAd',
      this.props.jobAd.slugs[this.props.jobAd.slugs.length - 1]
    )
    window.sessionStorage.setItem('careersCsrf', csrfToken)
  }

  onLinkedInProfileData(linkedInData) {
    const { dispatch } = this.props
    const { name = {}, email = {} } = this.props.jobAd.formSetup

    this.setState({
      linkedInPictureUrl: linkedInData.profilePicture,
      linkedInName: `${linkedInData.firstName} ${linkedInData.lastName}`,
    })

    if (email.visible) {
      dispatch(actions.change('application.email', linkedInData.email))
    }

    if (name.visible) {
      dispatch(
        actions.change(
          'application.name',
          `${linkedInData.firstName} ${linkedInData.lastName}`
        )
      )
    }
  }

  submitAdditionalFieldsForm() {
    const { jobAd } = this.props
    const visibleFields = jobAd.additionalFormFields.filter(
      field => field.fieldSetup.visible
    )
    if (visibleFields.length > 0) {
      document.additionalFieldsForm.submit()
    }
  }

  checkAdditionalFieldsValidity(fields) {
    const { invalidFields } = this.state

    Object.keys(fields).forEach(key => {
      const isInInvalidFields = invalidFields.indexOf(key) > -1
      const validField = fields[key].valid
      if (!validField && !isInInvalidFields) {
        this.setState({
          invalidFields: [...invalidFields, key],
        })
      } else if (validField && isInInvalidFields) {
        const filtered = invalidFields.filter(id => id !== key)
        this.setState({ invalidFields: filtered })
      }
    })
  }

  hasValidation(field) {
    const { context } = this.props
    if (context === 'careers' && field.required) {
      return true
    }
    return false
  }

  render() {
    const {
      name = {},
      coverLetter = {},
      email = {},
      attachments = {},
      phoneNumber = {},
      links = {},
      city = {},
    } = this.props.jobAd.formSetup
    const {
      preview,
      i18n,
      jobAd,
      application,
      company,
      context,
      submitApplication,
    } = this.props
    const visibleFields = jobAd.additionalFormFields.filter(
      field => field.fieldSetup.visible
    )
    const {
      loading,
      linkedInPictureUrl,
      linkedInName,
      linkedInAuthorizationCode,
      linkedInError,
    } = this.state
    const onSubmitApplication =
      context === 'careers' ? this.onSubmitApplication : submitApplication
    const formattedDateTime =
      jobAd.endTime &&
      `${moment(jobAd.endTime).format('L')} ${moment(jobAd.endTime).format(
        'LT'
      )}`

    const iconRight = jobAd.language === 'ar' ? 'west' : 'east'

    const showContinueIcon =
      jobAd.questions.length > 0 && jobAd.formSetup.questions.visible
    return (
      <>
        <Form
          className="job-ad-apply"
          id="application-form"
          name="applicationForm"
          model="application"
          onUpdate={form => {
            this.setState({ applicationForm: form && form.$form })
          }}
        >
          <PageContent size="small" mt="s24">
            <H3>{i18n.jobAdApplication.legendBasicInfo}</H3>
            <Body>{i18n.jobAdApplication.required}</Body>
            {name.visible ? (
              <FormGroup model="application.name">
                <LabelledInput
                  title={i18n.jobAdApplication.name}
                  isRequired={this.hasValidation(name)}
                  model="application.name"
                  validators={this.hasValidation(name) ? { isRequired } : null}
                  validateOn="change"
                  type="text"
                  placeholder={i18n.jobAdApplication.namePlaceholder}
                />
              </FormGroup>
            ) : null}
            {email.visible ? (
              <FormGroup model="application.email">
                <LabelledInput
                  title={i18n.jobAdApplication.email}
                  isRequired={this.hasValidation(email)}
                  model="application.email"
                  validators={
                    this.hasValidation(email)
                      ? { isRequired, isEmail }
                      : { isEmail }
                  }
                  validateOn="change"
                  type="email"
                  placeholder={i18n.jobAdApplication.emailPlaceholder}
                />
              </FormGroup>
            ) : null}
            {phoneNumber.visible ? (
              <FormGroup model="application.phone" name="application.phone">
                <Label color="grey90">{`${i18n.jobAdApplication.phone}${
                  phoneNumber.required ? '*' : ''
                }`}</Label>
                <PhoneInput
                  model="application.phone"
                  isRequired={this.hasValidation(phoneNumber)}
                  useRtl={jobAd.language === 'ar'}
                />
                <FormErrors model="application.phone" />
              </FormGroup>
            ) : null}
            {city.visible ? (
              <FormGroup model="application.city">
                <LabelledInput
                  title={i18n.jobAdApplication.city}
                  isRequired={this.hasValidation(city)}
                  model="application.city"
                  validators={this.hasValidation(city) ? { isRequired } : null}
                  validateOn="change"
                  type="text"
                  placeholder={i18n.jobAdApplication.cityPlaceholder}
                />
              </FormGroup>
            ) : null}
            {links.visible ? (
              <FormGroup model="application.links">
                <LinkListInput
                  model="application.links"
                  setup={links}
                  readOnly={preview}
                  placeholder={
                    i18n.jobAdApplication.links + (links.required ? '*' : '')
                  }
                  isRequired={this.hasValidation(links)}
                />
              </FormGroup>
            ) : null}
            {attachments.visible ? (
              <Attachments
                model="application.attachments"
                description={attachments.description}
                limit={5}
                readOnly={preview}
                isRequired={this.hasValidation(attachments)}
              />
            ) : null}
            {coverLetter.visible ? (
              <FormGroup model="application.coverLetter">
                <LabelledTextArea
                  title={i18n.jobAdApplication.coverLetter}
                  isRequired={this.hasValidation(coverLetter)}
                  model="application.coverLetter"
                  readOnly={preview}
                  validators={
                    this.hasValidation(coverLetter) ? { isRequired } : null
                  }
                  rows={10}
                  validateOn="change"
                  type="text"
                  placeholder={i18n.jobAdApplication.introduction}
                />
              </FormGroup>
            ) : null}
            {visibleFields.length > 0 && (
              <FormGroup model="application.additionalFieldResponses">
                <AdditionalFieldsForm
                  legend={i18n.jobAdApplication.legendAdditionalFields}
                  additionalFormFields={visibleFields}
                  responses={application.additionalFieldResponses}
                  changeAction={(model, value) => {
                    this.onChange(model, value)
                  }}
                  isFormValid={fields =>
                    this.checkAdditionalFieldsValidity(fields)
                  }
                />
              </FormGroup>
            )}
            <FormGroup model="application.agreeTOS">
              <AgreeTos
                model="application.agreeTOS"
                agreed={application.agreeTOS}
                onChange={value => this.onChange('application.agreeTOS', value)}
                privacyLink={jobAd.privacyPolicy}
                validators={context === 'admin' ? null : { isRequired }}
              />
            </FormGroup>
          </PageContent>
          <ActionBarWrapper
            hideBeforeScroll
            getActionBarRoot={
              context === 'admin' ? getPreviewActionBarRoot : undefined
            }
            leftSideComponent={
              formattedDateTime && (
                <Body fontWeight={600}>
                  {i18n.jobAdContainer.endTime(formattedDateTime)}
                </Body>
              ) // TODO: replace with Apply Before: ${date} when apply before is translated
            }
            actions={
              <Button
                text={
                  jobAd.questions.length > 0 &&
                  jobAd.formSetup.questions.visible
                    ? i18n.jobAdApplication.continue
                    : i18n.jobAdApplication.submit
                }
                event={{
                  locationId: 'jobAdApplyPage',
                  id: 'applicationSubmitButton',
                  properties: {
                    companyId: company._id,
                    companyName: company.name,
                    language: jobAd && jobAd.language,
                  },
                }}
                iconRight={showContinueIcon ? iconRight : undefined}
                icon={!showContinueIcon ? 'save' : undefined}
                onClick={onSubmitApplication}
                loading={loading}
              />
            }
          />
          {context === 'careers' && <ThirdPartyScripts />}
        </Form>
      </>
    )
  }
}

JobAdApply.propTypes = propTypes
JobAdApply.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps(mapStateToProps))(JobAdApply)
